export enum HMSPollUserTrackingMode {
  /**
   User tracking is based on the peer ID.
   */
  peerID,

  /**
   User tracking is based on the customer ID.
   */
  customerUserID,

  /**
   User tracking is based on the username.
   */
  userName,
}
